export default __webpack_public_path__ + "slices/main/assets/public/media/bcorp-logo.52e727def124ebf21d4cf58d74b7db47.png";